import ferdous from "../assets/avatars/ferdous.png";
import akash from "../assets/avatars/akash.png";
import almas from "../assets/avatars/almas.png";
import riyadh from "../assets/avatars/riyadh.png";
import sadh from "../assets/avatars/sadh.png";
import salahuddin from "../assets/avatars/salahuddin.png";
import sumit from "../assets/avatars/sumit.png";

export default function Member({ member }) {
  const { name, avatar } = member;

  let avatarSrc;
  switch (avatar) {
    case "/images/avatars/ferdous.png":
      avatarSrc = ferdous;
      break;
    case "/images/avatars/akash.png":
      avatarSrc = akash;
      break;
    case "/images/avatars/almas.png":
      avatarSrc = almas;
      break;
    case "/images/avatars/riyadh.png":
      avatarSrc = riyadh;
      break;
    case "/images/avatars/sadh.png":
      avatarSrc = sadh;
      break;
    case "/images/avatars/salahuddin.png":
      avatarSrc = salahuddin;
      break;
    case "/images/avatars/sumit.png":
      avatarSrc = sumit;
      break;
    default:
      avatarSrc = undefined;
  }

  return (
    <div className="checkbox-container">
      <img src={avatarSrc} className="team-avater" alt="avatar" />
      <p className="label">{name}</p>
    </div>
  );
}
